import { Feed, getPersonFullName } from '@mntn-dev/ui-components'
import { ActivityTrans } from '../activity-trans.tsx'
import { Link } from '../index.ts'
import type { ActivityDetailsProps } from './types.ts'

export const ProjectCreated = ({
  activity: {
    person,
    details: { activityType, data },
  },
  t,
  onNavigate,
  currentUrl,
}: ActivityDetailsProps<'project_created'>) =>
  person && (
    <>
      <Feed.Summary>
        <ActivityTrans
          t={t}
          i18nKey={`${activityType}.summary`}
          values={{ subject: getPersonFullName(person), package: data.package }}
        />
      </Feed.Summary>
      <Feed.Annotations>
        <Feed.Tag type="default">{t(`${activityType}.status`)}</Feed.Tag>
        <Link {...{ target: data.package, t, onNavigate, currentUrl }} />
      </Feed.Annotations>
    </>
  )
